import React from "react";
import { Link } from "react-router-dom";
import { PATHS } from "../../constant";
import { OrganizationTemplate, MultipleTags } from "../reusableComponent";
import { getColor, formatNumber } from "../../helper";

const ProjectInformationSection = props => {
  const { projectData, showAddDecisionSection, isUserPMG } = props;

  if (!projectData) {
    return null; // or a loader if you prefer
  }
  const projectPPList =
    projectData && projectData.projectPPList && projectData.projectPPList.length
      ? projectData.projectPPList
      : [];
  function getUniqueOrganizations(data) {
    // Filter out null values before creating the set
    const filteredData = data.filter(item => item.organizationGroup !== null);
    // Create a Set to store unique organization groups
    const uniqueOrgs = new Set(
      filteredData.map(item => item.organizationGroup)
    );
    // Convert the Set back to an array
    return Array.from(uniqueOrgs);
  }
  const uniqueOrganizations = getUniqueOrganizations(projectPPList);
  return (
    <div className="issue-list-content add-decision-project">
      <div className="issue-list-multiple add-decision-issue">
        <div className="select-issue-list-wrapper">
          <div className="decision-project-overview">
            <div className="project-no d-flex justify-content-between align-items-start">
              <div>
                Project
                <span className="project-id">
                  <Link
                    to={{
                      pathname: PATHS.PROJECT_DETAILS,
                      search: "?projectId=".concat(
                        projectData && projectData.id ? projectData.id : 0
                      )
                    }}
                  >
                    #PMG-{projectData.id || 0}
                  </Link>
                </span>
                {/* {projectPPList &&
                  projectPPList.map(item => {
                    if (item.organizationGroup) {
                      return (
                        <OrganizationTemplate
                          title={item.organizationGroup}
                          classes="organisation-name"
                        />
                      );
                    }
                  })} */}
                {uniqueOrganizations.map((organization, index) => (
                  <OrganizationTemplate
                    key={index}
                    title={organization}
                    classes="organisation-name"
                  />
                ))}
                <div id="agenda-detail-issue-list">
                  <MultipleTags
                    containerClass="select-issue-single-stages"
                    options={[
                      {
                        title:
                          projectData.projectStatusWithRespectToIssueStatus &&
                          projectData.projectStatusWithRespectToIssueStatus !==
                            "NO ISSUES"
                            ? projectData.projectStatusWithRespectToIssueStatus
                            : "",
                        classes:
                          projectData.projectStatusWithRespectToIssueStatus &&
                          projectData.projectStatusWithRespectToIssueStatus !==
                            "NO ISSUES"
                            ? getColor(
                                projectData.projectStatusWithRespectToIssueStatus
                              )
                            : ""
                      },
                      {
                        title:
                          projectData.projectCompletionDTO.status !==
                          "NO IMPLEMENTATION"
                            ? projectData.projectCompletionDTO.status
                            : "",
                        classes:
                          projectData.projectCompletionDTO.status !==
                          "NO IMPLEMENTATION"
                            ? getColor(projectData.projectCompletionDTO.status)
                            : ""
                      }
                    ]}
                  />
                </div>
              </div>

              <div>
                {isUserPMG && (
                  <span>
                    <button
                      type="button"
                      class="btn-orange btn add-decision-button"
                      onClick={showAddDecisionSection}
                    >
                      Add Decision
                    </button>
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <h2
                  className={`project-heading ${
                    /[\u0900-\u097F]/.test(projectData.name || "")
                      ? "hindi-text-wrap"
                      : ""
                  }`}
                >
                  {projectData.name}
                </h2>
                <div className="sponsor">
                  Sponsored by -{" "}
                  <span className="sponsor-desc decision-sponsor-issue">
                    {projectData.sponsoredBy}
                  </span>
                  <span className="seperator">|</span>
                  Issue(s) Open -{" "}
                  <span className="sponsor-desc decision-sponsor-issue">
                    {projectData.openIssuesCount || 0}
                  </span>
                  <span className="seperator">|</span>
                  Issue(s) Resolved -{" "}
                  <span className="sponsor-desc decision-sponsor-issue">
                    {projectData.resolvedIssuesCount || 0}
                  </span>
                </div>
              </div>
              <div>
                <div className="add-decision-cost">
                  <div className="cost-heading">Project Cost</div>
                  <div className="cost">
                    ₹{" "}
                    {projectData.totalCost
                      ? formatNumber(projectData.totalCost || projectData.cost)
                      : formatNumber(projectData.revisedCost) ||
                        projectData.cost}{" "}
                    Cr.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectInformationSection;
